import logbookService from "@/services/dailyLogbook";
import router from "../../router/index";
import { cloneDeep } from "lodash"
const getDefaultState = () => {
  return {
    logbookData: [],
    dashboardCounts: [],
    loadingStatus: false,
    ScanDataTypes: [],
    inputTypes: [],
    userTypes: [],
    areas: [],
    kiosks: [],
    devices: [],
    multipleUsersData: {},
    checkingUsersInLoaderStatus: false
  }
}

export const state = getDefaultState();

export const actions = {
  async resetDashboardData({ commit }) {
    await commit("logbookData", null);
  },
  async getAll({ commit, dispatch }, params) {
    commit("grid/setLoading", true, { root: true });
    commit("grid/setRecordsCount", null, { root: true });
    await dispatch("resetDashboardData");
    return new Promise((resolve, reject) => {
      logbookService
        .getAll(params)
        .then((data) => {
          resolve(data);
          console.log('logbook', data.data.data, params);
          commit("logbookData", data.data.data);
          commit("grid/setRecordsCount", data.data.count, { root: true });
          commit("grid/setLoading", false, { root: true });
        })
        .catch((err) => {
          commit("grid/setLoading", false, { root: true });
          reject(err);
        });
    });
  },
  getCounts({ commit }) {
    return new Promise((resolve, reject) => {
      logbookService
        .getCounts()
        .then((data) => {
          commit("dashboardCounts", data.data.totals.daily);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchScanDatatypes({ commit }) {
    return new Promise((resolve, reject) => {
      logbookService
        .getScanDatatypes()
        .then((data) => {
          commit("setScanDataTypes", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchScanDatatypesForDashboard({ commit }) {
    return new Promise((resolve, reject) => {
      logbookService
        .getScanDatatypesForDashboard()
        .then((data) => {
          commit("setScanDataTypes", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchInputTypes({ commit }) {
    return new Promise((resolve, reject) => {
      logbookService
        .getInputTypes()
        .then((data) => {
          commit("setInputTypes", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchAreas({ commit }) {
    return new Promise((resolve, reject) => {
      logbookService
        .getAreas()
        .then((data) => {
          commit("setAreas", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchKiosks({ commit }) {
    return new Promise((resolve, reject) => {
      logbookService
        .getKiosks()
        .then((data) => {
          commit("setKiosks", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchDevices({ commit }) {
    return new Promise((resolve, reject) => {
      logbookService
        .getDevices()
        .then((data) => {
          commit("setDevices", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchUserTypes() {
    return new Promise((resolve, reject) => {
      logbookService
        .getUserTypes()
        .then((data) => {
          // commit("setUserTypes", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  scanAttendances({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      logbookService
        .scanAction(payload)
        .then((data) => {
          dispatch("notification/success", data.message, { root: true });
          resolve(data);
          dispatch("getAll");
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchScansOfVisit({ commit }, viditId) {
    commit("setLoadingStatus", false);
    return new Promise((resolve, reject) => {
      logbookService
        .getScansOfVisit(viditId)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  fetchCustomFieldsOfScan({ commit }, scanId) {
    commit("setLoadingStatus", false);
    return new Promise((resolve, reject) => {
      logbookService
        .getCustomFieldsOfScan(scanId)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          err.status != 401 && !err.data.otp_error && this._vm.$toast.error(err.data.message);
        });
    });
  },
  dashboardAction({ dispatch, commit }, params) {
    commit("setLoadingStatus", true);
    return new Promise((resolve, reject) => {
      logbookService
        .dashboardAction(params)
        .then((data) => {
          this._vm.$toast.success("Visit Added");
          resolve(data);
          router.history.current.path != "/" &&
            router.push("/");
          dispatch("getAll");
          dispatch("getCounts");
          commit("modal/setModalState", true, { root: true });
          setTimeout(() => {
            commit("setLoadingStatus", false);
          }, 1000);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message ? err.data.message : err.data.data);
          commit("modal/setModalState", false, { root: true });
          commit("setLoadingStatus", false);
        });
    });
  },
  checkInUserAction({ dispatch, commit }, params) {
    commit("setLoadingStatus", true);
    return new Promise((resolve, reject) => {
      logbookService
        .checkInUserAction(params)
        .then((data) => {
          this._vm.$toast.success("Visit Added");
          resolve(data);
          const currentPath = router.history.current.path
          // if (currentPath != "/" && currentPath != "/reporting/users-not-on-site") router.push("/");
          if (currentPath != "/reporting/users-not-on-site") {
            dispatch("getAll");
            dispatch("getCounts");
          }
          commit("modal/setModalState", true, { root: true });
          setTimeout(() => {
            commit("setLoadingStatus", false);
          }, 1000);
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(Object.values(err.data.errors).join('\r\n'));
          commit("modal/setModalState", false, { root: true });
          commit("setLoadingStatus", false);
        });
    });
  },
  fetchMultipleUsersData({ commit }, params) {
    commit('setLoadingStatus', true)
    return new Promise((resolve, reject) => {
      logbookService.getUsersDataMassAction(params.payload)
        .then(data => {
          let lateSignInReasons = [], earlySignOutReasons = [], attendanceCodeIfNoReasons = "";
          const selectedUsersIds = data?.data[0]?.users?.map(user => user.id)
          let compliancesMap = new Map();
          let checksSet = new Set()
          let area = data?.data[0]?.area;
          const userTypeId = data?.data[0].user_type?.id
          const site_id = params.site_id

          console.log(data)
          //Attendance code reasons
          data?.data[0]?.users?.forEach(user => {
            //Set Sign in reasons if exists
            if (user.signedOut && !lateSignInReasons?.length && user.attendance_mode?.reasons?.length) {
              let id = 1;
              user.attendance_mode.reasons.forEach(reason => {
                if (reason.presented?.length) {
                  reason.presented?.forEach((presentedReason) => {
                    lateSignInReasons.push({
                      name: presentedReason,
                      isPresented: true,
                      reason_id: reason.id,
                      attendance_code: reason.attendance_code?.id || user.attendance_mode?.attendanceCodeInMode?.id || "",
                      id
                    })
                    id++;
                  });
                } else {
                  lateSignInReasons.push({
                    name: reason.name,
                    isPresented: false,
                    reason_id: reason.id,
                    attendance_code: reason.attendance_code?.id || user.attendance_mode?.attendanceCodeInMode?.id || "",
                    id
                  });
                  id++;
                }
              })
            }
            //Set Sign out reasons if exists
            else if (!user.signedOut && !earlySignOutReasons.length && user.attendance_mode?.reasons?.length) {
              let id = 1;
              user.attendance_mode.reasons.forEach(reason => {
                if (reason.presented?.length) {
                  reason.presented?.forEach((presentedReason) => {
                    earlySignOutReasons.push({
                      name: presentedReason,
                      isPresented: true,
                      reason_id: reason.id,
                      attendance_code: reason.attendance_code?.id || user.attendance_mode?.attendanceCodeInMode?.id || "",
                      id
                    })
                    id++
                  });
                } else {
                  earlySignOutReasons.push({
                    name: reason.name,
                    isPresented: false,
                    reason_id: reason.id,
                    attendance_code: reason.attendance_code?.id || user.attendance_mode?.attendanceCodeInMode?.id || "",
                    id
                  });
                  id++
                }
              })
            } else {
              attendanceCodeIfNoReasons = user.attendance_mode?.attendanceCodeInMode?.id || ""
            }
          })

          let allSections = []
          //Get all sections on grid to esnures that the section data on all users have
          //the same order to avoid swapping column headers between different sections
          data?.data[0].users?.forEach(userData=>{
            if(userData.sections && !!userData.sections.length){
              userData.sections.forEach(section=>{
                if(!allSections.some(sec => sec.id == section.id)){
                  allSections.push(section)
                }
              })
            }
          })
          
          /**
           * Check if every compliance is required or not for every user
           * ex. compliancesMap => {'complianceId':[true,false,true]}
          */
          data?.data[0]?.users?.forEach(userData => {
            Object.assign(userData, { status: "" })
            //Checks (If all users are signing out ,display '-' in mass action row)
            checksSet.add(userData.signedOut)

            //compliances
            userData?.complinaces?.forEach(compliance => {
              const isExpected = compliance.pivot && Object.keys(compliance.pivot)?.length > 0
              const hasComplianceId = compliancesMap.has(compliance.id)
              if (!hasComplianceId) compliancesMap.set(compliance.id, [userData.signedOut && (compliance.isRequired || (!compliance.isRequired && isExpected))])
              else compliancesMap.get(compliance.id).push((userData.signedOut && (compliance.isRequired || (!compliance.isRequired && isExpected))))
            })

            //document
            if (userData.documents && userData.documents?.length) {
              const complianceDocument = userData.documents[0]?.complianceDocument[1] || userData.documents[0]?.complianceDocument[0]
              const isExpected = complianceDocument?.pivot && Object.keys(complianceDocument?.pivot)?.length > 0 && !userData.all ? true : false
              const document = userData.documents[0].complianceDocument[0]
              const hasDocumentId = compliancesMap.has(document.id)
              if (!hasDocumentId) compliancesMap.set(document.id, [userData.signedOut && (document.isRequired || (!document.isRequired && isExpected))])
              else compliancesMap.get(document.id).push((userData.signedOut && (document.isRequired || (!document.isRequired && isExpected))))
            }
            
            // 'readOnly' flag indicates that the cell will 
            // be displayed as '-'
            //'readOnly' section will have all custom fields 'isActive' set to false
            if(userData.sections && !!userData.sections.length){
              let currentUserSections = []
              allSections.forEach(allSection=>{
                const currentSection = userData.sections.find(userSection => userSection.id == allSection.id)
                //User has some of all section(s)
                //assign readOnly accordingly
                if(currentSection){
                  //Assign default values for data binding
                  currentSection.custom_fields?.forEach(field=>{
                    let defaultValue = null;

                    if (field.type == "checkboxes")
                      defaultValue = field.value || [];
                    else if (field.type == "toggleButton")
                      defaultValue = field.value || false;
                    else if (
                      field.type == "number" ||
                      field.type == "longText" ||
                      field.type == "text"
                    )
                      defaultValue = field.value || "";
                    else defaultValue = field.value || null;
          
                    Object.assign(field, {
                      value: defaultValue,
                      sectionType: Number(currentSection.type),
                      isActive: true
                    });
                  })

                  currentSection.readOnly = false
                  currentUserSections.push(currentSection)

                }else{
                  allSection.readOnly = true
                  allSection.custom_fields?.forEach(field=>field.isActive = false)
                  currentUserSections.push(allSection)
                }
              })
              userData.sections = cloneDeep(currentUserSections)
            }else{
              //User with NO sections
              userData.sections = cloneDeep(allSections)?.map(section=>{
                section.custom_fields?.forEach(field=>field.isActive = false)
                section.readOnly = true
                return section
              })
            }
          })

          //Set massActionCompliances for 'All action' if same user type
          const massActionCompliances = data?.data[0]?.users[0]?.complinaces?.length ? JSON.parse(JSON.stringify(data?.data[0]?.users[0]?.complinaces))?.map(compliance => { return { ...compliance, allAction: true } }) : [];
          massActionCompliances?.length > 0 && massActionCompliances?.forEach(compliance => {
            const isComplianceRequiredArray = compliancesMap.has(compliance.id) ? compliancesMap.get(compliance.id) : null
            if (isComplianceRequiredArray) {
              Object.assign(compliance, { isRequired: isComplianceRequiredArray.includes(true) })
            }
            compliance.form_metadata && Object.assign(compliance.form_metadata, { notes: "", isDirty: false, status: null })
          })


          //Assign attendance reasons to every user
          data?.data[0]?.users.forEach(userData => {
            Object.assign(userData, {
              earlySignOutReason: earlySignOutReasons?.length == 1 ? earlySignOutReasons[0] : null,
              lateSignInReason: lateSignInReasons?.length == 1 ? lateSignInReasons[0] : null,
              showLateSignInReason: userData.signedOut && userData.attendance_mode?.reasons?.length && lateSignInReasons?.length > 1,
              showEarlySignOutReason: !userData.signedOut && userData.attendance_mode?.reasons?.length && earlySignOutReasons?.length > 1,
              lateSignInReasonsOptions: userData.signedOut ? lateSignInReasons : [],
              earlySignOutReasonsOptions: !userData.signedOut ? earlySignOutReasons : [],
              attendanceCodeIfNoReasons
            })
          })

          /** start::TODO (BACKEND)*/
          data?.data[0]?.users?.unshift({
            all: "All",
            full_name: "",
            complinaces: massActionCompliances,
            documents: data?.data[0]?.users[0]?.documents?.map(document => {
              return { ...document, allAction: true, isRequired: compliancesMap.get(document.complianceDocument[0].id).includes(true) }
            }),
            notes: "",
            id: "",
            site_id,
            checks: data?.data[0]?.users[0]?.checks, //Case => All users have same checks (#TODO)
            showChecksFillinButton: checksSet.has(true),
            showLateSignInReason: lateSignInReasons?.length > 1,
            showEarlySignOutReason: earlySignOutReasons?.length > 1,
            lateSignInReasonsOptions: lateSignInReasons,
            lateSignInReason: null,
            earlySignOutReasonsOptions: earlySignOutReasons,
            earlySignOutReason: null,
            sections: allSections?.map(section=>{
              section?.custom_fields?.forEach(field=>{
                field.isActive = false;
              })
              return section
            })
          });

          //Assign 'checksModel' to every user
          data?.data[0]?.users?.forEach(userData => {
            let temperature_check = false, mask_check = false, host_check = false, allow_no_host_select = false, temperature_threshold = 0, select_host_permitted = false;
            userData.checks?.forEach(check => {
              if (check.name == "temperature_check" && check.value == 1) temperature_check = true;
              if (check.name == "mask_check" && check.value == 1) mask_check = true
              if (check.name == "host" && check.value) host_check = check.value
              if (check.name == "allow_not_select_host" && check.value == 1) allow_no_host_select = true
              if (check.name == "select_host_permitted") select_host_permitted = check.value
              if (check.name == 'temperature_threshold') {
                if (
                  check.value
                    ?.toString()
                    ?.toLowerCase()
                    .includes("f") ||
                  parseFloat(check.value) > 85
                )
                  temperature_threshold =
                    ((parseFloat(check.value) - 32) * 5) / 9;
                else temperature_threshold = check.value;
              }

            })
            //Assign 'checksModel' object to any user with checks (Temperature/Mask)
            if (temperature_check && mask_check) {
              Object.assign(userData, {
                checksModel: {
                  mask: { currentValue: false },
                  temperature: { currentValue: 36, unitType: "c", temperature_threshold: temperature_threshold },
                  user_id: userData.id,
                  type: "checks",
                  isDirty: false,
                  allAction: userData.all ? true : false,
                }
              }
              )
            } else if (temperature_check) {
              Object.assign(userData, {
                checksModel: {
                  temperature: { currentValue: 36, unitType: "c", temperature_threshold: temperature_threshold },
                  user_id: userData.id,
                  type: "checks",
                  isDirty: false,
                  allAction: userData.all ? true : false,
                }
              }
              )
            } else if (mask_check) {
              Object.assign(userData, {
                checksModel: {
                  mask: { currentValue: false },
                  user_id: userData.id,
                  type: "checks",
                  isDirty: false,
                  allAction: userData.all ? true : false,
                }
              }
              )
            } else {
              Object.assign(userData, { checks: [] })
            }

            //Assign 'hostModel' object to any user with host checks
            if (host_check) {
              Object.assign(userData, {
                hostModel: {
                  hosts: host_check.split(","),
                  allow_no_host_select,
                  select_host_permitted,
                  no_host_selected: userData.host === true ? true : false,
                  selectedHost: userData.host && userData.host !== true && userData.host.user_id ? { name: userData.host, id: userData.host.user_id } : { name: "", id: "" },
                  type: "host",
                  allAction: userData.all ? true : false,
                  isDirty: userData.host ? true : false,
                  [userData.all ? "host_user_ids" : "host_user_id"]: userData.all ? selectedUsersIds : userData.id,
                  journey_flow_id: userData.all ? data?.data[0]?.users[1]?.journey_flow_id : userData.journey_flow_id,
                  user_id: userData.id,
                  user_type_id:userTypeId,
                  site_id,
                  area : area,
                  hostMessage:""
                }
              })
            }

            //Assign 'Admin notes to all users'
            Object.assign(userData, { adminNotes: { isDirty: false, notes: "" } })

          })


          data?.data[0]?.users?.forEach(userData => {
            //Filled in (Expected) binding for compliances(Questionnaire , agreement)
            userData?.complinaces?.forEach((compliance) => {
              if (!userData.all) {
                if (compliance.pivot && Object.keys(compliance.pivot)?.length) {
                  let isWrong = false
                  compliance.form_metadata?.questions?.forEach((_, questionIndex) => {
                    //answer for each answer in a compliance
                    // const answer = compliance.pivot?.metadata[questionIndex]?.answer?.desired == 'true' ? true : false
                    compliance.form_metadata.questions[questionIndex].finalAnswers = compliance.pivot?.metadata[questionIndex]?.answer || {}
                    //Check if any of the answers is wrong (not desired) set status to failed
                    if (!isWrong) isWrong = compliance.pivot.metadata[questionIndex].isWrong
                  })

                  // get name & role from first question 
                  const actionByRole = compliance.pivot?.metadata[0].actionBy
                  const actionByName = compliance.pivot?.full_name_action_by
                  const notes = compliance.pivot?.metadata[0].notes || ""
                  compliance.form_metadata && Object.assign(compliance.form_metadata, { notes: notes, status: isWrong & notes.length < 20 ? 'failed' : 'success', isDirty: true, actionByRole: actionByRole, actionByName: actionByName, isExpected: true })
                } else {
                  compliance.form_metadata && Object.assign(compliance.form_metadata, { notes: "", status: null, isDirty: false })
                }
              }
            })

            // Document check and binding
            if (userData?.documents && userData?.documents.length) {
              const complianceDocument = userData.documents[0]?.complianceDocument[1] || userData.documents[0]?.complianceDocument[0]
              const actionByRole = complianceDocument.pivot?.metadata?.actionBy || null
              const actionByName = complianceDocument.pivot?.full_name_action_by || null
              const updatedAt = complianceDocument.pivot?.updated_at || null
              const notes = complianceDocument.pivot?.metadata?.notes || ""
              const questions = complianceDocument?.form_metadata
                ?.data[0]?.answers || null;
              const isOptional = questions?.length && questions[0]?.desired && questions[1]?.desired
                ? true
                : false
              const isFilledInCopmpliance = complianceDocument?.pivot && Object.keys(complianceDocument?.pivot)?.length && !userData.all ? true : false
              const filledInComplianceIsWrong = complianceDocument.pivot?.metadata?.isWrong && !isOptional

              let status = ""
              if (isFilledInCopmpliance) {
                if (filledInComplianceIsWrong) status = 'failed'
                else if (isOptional) status = 'completed'
                else if (!filledInComplianceIsWrong) status = 'success'
              }

              const selectedDocument = isFilledInCopmpliance ? JSON.parse(complianceDocument.pivot?.user_documents_metadata) : null
              if (selectedDocument) Object.assign(selectedDocument, { type: complianceDocument.pivot?.user_documents_type })
              Object.assign(userData.documents[0], {
                documentModel: {
                  user_id: userData.id,
                  vaccine_pcr: "vaccine",
                  selectedDocument,
                  vaccine_name: null,
                  vaccine_protocol: null,
                  batch_number: null,
                  vaccine_date_taken: null,
                  vaccine_expiry_date: null,
                  vaccine_pcr_file: null,
                  documentFile: { img: "", err: "" },

                  pcr_result: null,
                  pcr_date_taken: null,
                  document_notes: "",
                  compliance_notes: notes,
                  isFilledInCopmpliance,
                  filledInComplianceNotes: complianceDocument.pivot?.metadata?.notes || "",
                  isDirty: isFilledInCopmpliance,
                  actionByRole: actionByRole ?? null,
                  actionByName: actionByName ?? null,
                  updatedAt,
                  status
                }
              }, {
                isOptional
              }
              )
            }
          })
          /** end::TODO */

          commit('setMultipleUsersData', data.data)
          commit('setLoadingStatus', false)
          resolve(data)
        }).catch(err => {
          commit('setLoadingStatus', false)
          reject(err);
          this._vm.$toast.error(err.data?.message ? err.data.message : err.data?.data);
        });
    })
  },
  massActionCheckInUsers({ commit }, payload) {
    commit("setCheckingUsersInLoader", true)
    return new Promise((resolve, reject) => {
      logbookService.massActionCheckInUsers(payload).then(data => {
        resolve(data)
        commit("setCheckingUsersInLoader", false)
      }).catch(err => {
        commit("setCheckingUsersInLoader", false)
        reject(err);
        this._vm.$toast.error(err.data.message ? err.data.message : err.data.data);
      })
    })
  },
  clearMultipleUsersData({ commit }) {
    commit("clearMultipleUsersData")
  },
  resetState({ commit }) {
    commit("setLoadingStatus", false);
  },
  addVisitNotes({ commit }, payload) {
    commit("preRegistration/setRefreshGrid", false, { root: true });
    commit("setLoadingStatus", false);
    return new Promise((resolve, reject) => {
      console.log('add', payload);
      logbookService
        .addVisitNotes(payload)
        .then((data) => {
          // this._vm.$toast.success("Visit Notes Added");
          resolve(data);
          commit("preRegistration/setRefreshGrid", true, { root: true });
        })
        .catch((err) => {
          reject(err);
          this._vm.$toast.error(err.data.message ? err.data.message : err.data.data);
        });
    });
  }
};

export const mutations = {
  resetDashboardState(state) {
    // Merge rather than replace so we don't lose observers
    Object.assign(state, getDefaultState())
  },
  setLoadingStatus(state, loading) {
    state.loadingStatus = loading;
  },
  logbookData(state, payload) {
    state.logbookData = payload;
  },
  dashboardCounts(state, payload) {
    state.dashboardCounts = payload;
  },
  setScanDataTypes(state, payload) {
    state.ScanDataTypes = payload;
  },
  setInputTypes(state, payload) {
    state.inputTypes = payload;
  },
  setUserTypes(state, payload) {
    state.userTypes = payload;
  },
  setAreas(state, payload) {
    state.areas = payload;
  },
  setKiosks(state, payload) {
    state.kiosks = payload;
  },
  setDevices(state, payload) {
    state.devices = payload;
  },
  setMultipleUsersData(state, payload) {
    state.multipleUsersData = payload
  },
  setCheckingUsersInLoader(state, payload) {
    state.checkingUsersInLoaderStatus = payload
  },
  clearMultipleUsersData(state) {
    state.multipleUsersData = {}
  }
};

export const getters = {
  getLoadingStatus(state) {
    return state.loadingStatus;
  },
  getDashboardData(state) {
    return state.logbookData;
  },
  dashboardCounts(state) {
    return state.dashboardCounts;
  },
  getScanDataTypes(state) {
    return state.ScanDataTypes;
  },
  getInputTypes(state) {
    return state.inputTypes;
  },
  getUserTypes(state) {
    return state.userTypes;
  },
  getAreas(state) {
    return state.areas;
  },
  getKiosks(state) {
    return state.kiosks;
  },
  getDevices(state) {
    return state.devices;
  },
  getMultipleUsersData(state) {
    return state.multipleUsersData
  },
  getCheckinsUsersInLoaderStatus(state) {
    return state.checkingUsersInLoaderStatus
  }
};
